export enum COMMON_ACTION_TYPE {
  LIST = 'common/list',
  INQUIRY = 'common/inquiry',
}
